import { theme } from "@tm/utility/global";
import React from "react";
import styled from "styled-components";

import { FlexComp, FormattedText, ParaTag, SpanTag } from "@tm/static";

import {
  OrderRightCntnt,
  OrderRightStyle,
} from "../../../../components/OrderDetailRightComp/OrderDetailRightComp.style";
import type { OrderDetailV2PaymentInfoProps } from "../../types";
import { openDownloadUrl } from "../../utils/openDownloadUrl";

const PaymentHeader = styled.div<{ backgroundColor?: string }>`
  padding: 20px;
  background-color: ${theme.lightBlueBg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px 15px 0px 0px;
  gap: 10px;
`;

const OutlineButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px 20px;
  background: transparent;
  border: 2px solid ${theme.blueText};
  border-radius: 8px;
  color: ${theme.blueText};
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    background-color: ${theme.blueText};
    color: ${theme.whiteText};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 140, 255, 0.3);
  }
`;

export const OrderDetailV2PaymentInfo: React.FC<
  OrderDetailV2PaymentInfoProps
> = ({
  title,
  info,
  paymentBreakup,
  invoiceUrl,
  isActionDisabled,
  actionText,
}) => {
  const handleDownloadInvoice = () => {
    if (isActionDisabled || !invoiceUrl) return;
    openDownloadUrl(invoiceUrl);
  };

  return (
    <OrderRightStyle>
      <PaymentHeader>
        {title && (
          <SpanTag fontWeight="bold" fontSize="md">
            <FormattedText value={title} />
          </SpanTag>
        )}
        {info && (
          <SpanTag fontWeight="bold" fontSize="md">
            <FormattedText value={info} />
          </SpanTag>
        )}
      </PaymentHeader>
      <OrderRightCntnt>
        <div style={{ marginBottom: "8px" }}>
          <ParaTag fontWeight="bold" fontSize="xs" margin="0">
            <FormattedText value="Payment Breakup" />
          </ParaTag>
        </div>
        {paymentBreakup.map((payment, index) => (
          <FlexComp key={index} justifyContent="space-between" margin="8px 0">
            <ParaTag fontSize="xs" margin="0">
              <FormattedText value={payment.sourceText || "-"} />
            </ParaTag>
            <SpanTag fontSize="xs">
              <FormattedText value={payment.value || "-"} />
            </SpanTag>
          </FlexComp>
        ))}
        <OutlineButton
          disabled={isActionDisabled}
          onClick={handleDownloadInvoice}
          style={{ marginTop: "16px" }}
        >
          {actionText}
        </OutlineButton>
      </OrderRightCntnt>
    </OrderRightStyle>
  );
};
